"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var estiloLoading = require('./Loading.module.scss');
var react_1 = __importDefault(require("react"));
var Loading = function (_a) {
    var _b = _a.carregandoConteudo, carregandoConteudo = _b === void 0 ? false : _b;
    var _c = react_1.default.useState(carregandoConteudo), carregando = _c[0], setCarregando = _c[1];
    var Circle1 = (react_1.default.createElement("div", { className: "".concat(estiloLoading.circle1, " ").concat(carregando ? '' : estiloLoading.hidden) }));
    return (react_1.default.createElement("div", null, Circle1));
};
exports.Loading = Loading;
